import apiClient from './client'

export interface SiteInfo {
  name: string
  description: string
}

/** 站点信息（公开接口，登录前/后均可访问） */
export const getSiteInfo = async (): Promise<SiteInfo> => {
  const resp = await apiClient.post('/api/system/site', {})
  return resp.data.data
}
